import styled from 'styled-components';
import { _gridInput } from 'theme/_mixins/inputs';

import Button from 'components/Buttons/Button';
import CheckboxComponent from 'components/Checkbox';

interface FieldProps {
  columns?: number;
}

export const Container = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Fields = styled.ol`
  margin-top: 16px;

  @media ${({ theme }) => theme.device.mobile} {
    margin-bottom: 80px;
  }
`;

export const Field = styled.li<FieldProps>`
  ${({ columns }) => _gridInput({ gap: 8, columns, margin: { top: 8, bottom: 8 } })};
`;

export const SearchButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    left: 0;
    bottom: 0px;
    right: 0;
    width: 100%;
    margin-bottom: 32px;
  }
`;

export const SearchButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;
  width: 50%;
  margin-top: 16px;
  margin-left: auto;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 28px 16px 0px;
    width: 100%;
  }
`;

export const Checkbox = styled(CheckboxComponent)`
  cursor: pointer;
  & > span {
    border-radius: 4px;
  }

  @media ${({ theme }) => theme.device.desktop} {
    margin-left: auto;
  }
`;

export const ReturnOther = styled.h5`
  padding-left: 15px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.flightSearch.baggage};
`;
